import React from 'react'
import SearchContext from './SearchContext'
import SearchIcon from '@material-ui/icons/Search'
import SearchBar from '@opuscapita/react-searchbar'
import Grid from '@material-ui/core/Grid'
import InputBase from '@material-ui/core/InputBase'
import Button from '@material-ui/core/Button'
import { fade, makeStyles } from '@material-ui/core/styles'
import { Formik, Form, Field, useFormik } from 'formik'
import { useState } from 'react'
// search: {
//   position: 'relative',
//     borderRadius: theme.shape.borderRadius,
//       backgroundColor: fade(theme.palette.common.white, 0.15),
//         '&:hover': {
//     backgroundColor: fade(theme.palette.common.white, 0.25)
//   },
//   marginLeft: 0,
//     width: '100%',
//       [theme.breakpoints.up('sm')]: {
//     marginLeft: theme.spacing(1),
//       width: 'auto'
//   }
// },
const useStyles = makeStyles(theme => ({
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '80%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  inputRoot: {
    display: 'flex',
    color: 'inherit'
    //textTransform: 'uppercase'
  },
  inputInput: {
    display: 'flex',
    color: 'inherit',
    //textTransform: 'uppercase',
    padding: theme.spacing(1, 1, 1, 0),
    //vertical padding + font size from searchIcon,
    //paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '80%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '12ch'
      }
    }
  },
  sform: {
    marginRight: theme.spacing(4)
  },
  search: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: '100%'
    }
  }
}))

export default function Search (props) {
  const { globalFilter, SetGlobalFilter } = React.useContext(SearchContext)
  const classes = useStyles()
  const formik = useFormik({
    initialValues: {
      searchField: globalFilter,
      tooltip: props.tooltip,
      placeHolder: props.placeHolder
    },
    onSubmit: values => {
      //alert(JSON.stringify(values, null, 2))
      console.log('value andmed', JSON.stringify(values, null, 2))
      handleChangeSearch(values.searchField)
    }
  })
  const handleChangeSearch = e => {
    formik.values.searchField = e
    return SetGlobalFilter(e)
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <div>
        <SearchBar
          inputClassName={classes.inputInput}
          onSearch={handleChangeSearch}
          id='searchField'
          allowEmptySearch={true}
          minChars={3}
          isDynamic={false}
          translations={{
            tooltip: formik.values.tooltip,
            searchPlaceHolder: formik.values.searchField
          }}
          value={formik.values.searchField}
          onChange={formik.handleChange}
        />
      </div>
    </form>
  )
}
//  {JSON.stringify(globalFilter, null, 2)}
// https://github.com/OpusCapita/react-searchbar  searchbar component
// <div className={classes.searchIcon}>
//   <SearchIcon />
// </div>
// <InputBase
//   fullWidth={true}
//   id='searchField'
//   placeholder='Otsi autot…'
//   value={formik.values.searchField}
//   onChange={formik.handleChange}
//   classes={{
//     root: classes.inputRoot,
//     input: classes.inputInput
//   }}
//   inputProps={{ 'aria-label': 'search' }}
// />
//<Button type='submit' className={classes.searchIcon} />
